// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__AzLB5","link":"Breadcrumb_link__HwqSS","linkActive":"Breadcrumb_linkActive__HjP5+","arrow":"Breadcrumb_arrow__ms1Kj"};